import CustomTable from "@/components/CustomTable/CustomTable.vue";
import NavBar from '@/components/NavBar/NavBar.vue';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import { useToast } from "@/components/Toast/useToast";

export default {
  name: 'FormManagement',
  mixins: [LOGOUT],
  pageTitle: 'Form Management',
  setup() {
    const { showSuccess, showError, showWarning } = useToast();
    
    return {
      showSuccess,
      showError,
      showWarning
    };
  },
  components: {
    NavBar,
    CustomTable
  },
  data: () => ({
    services: [],
    service: "",
    service_name: '',
    selected_service_id: null,
    loading: false,
    columns: [
      { label: 'Service Name', key: 'service_name' },
      { label: 'Internal Use', key: 'internal_use' },
    ],
    servicesTableKey: 0,
  }),
  methods: {
    clean_form_modal() {
      if (this.selected_service_id !== null) {
        this.service_name = '';
      }
    },
    validate_input() {
      if (!this.service_name.trim()) {
        $('.name-error-message').removeClass('d-none');
        setTimeout(() => {
          $('.name-error-message').addClass('d-none');
        }, 3000);
        return false;
      }
      return true;
    },
    update_internal_use(service_id, internal_use){
      const TOKEN = localStorage.getItem('token');
      const GET_CUSTOM_SERVICE_API = `${API_BASE_URL}/verify_api/form_management_api/update_internal_use/`;
      
      const data = {
        service_id: service_id,
        internal_use: internal_use
      };
      $.ajax({
        url: GET_CUSTOM_SERVICE_API,
        method: 'POST',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        data: JSON.stringify(data),
        beforeSend: () => {
          this.loading = true;
        },
        success: () => {
          this.showSuccess('Internal use updated successfully!');
          this.loading = false;
          this.servicesTableKey++;
        },
        error: () => {
          this.loading = false;
          this.showError('Failed to update internal use');
        }
      });
    },
    get_custom_service(page = 1, search = "") {
      const TOKEN = localStorage.getItem('token');
      return new Promise((resolve, reject) => {
        let url = `${API_BASE_URL}/verify_api/form_management_api/get_custom_service_api/?page=${page}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        $.ajax({
          url: url,
          method: "GET",
          dataType: "json",
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          success: (data) => {
            resolve({
              count: data.count,
              results: data.results
            });
          },
          error: (xhr, status, error) => {
            reject(error);
          },
        });
      });
    },
    create_custom_service() {
      if (!this.validate_input()) {
        return;
      }
      const TOKEN = localStorage.getItem('token');

      const FORM_DATA = {
        service_name: this.service_name
      };
      const CREATE_CUSTOM_SERVICE_URL = `${API_BASE_URL}/verify_api/form_management_api/create_custom_service_api/`;

      $.ajax({
        url: CREATE_CUSTOM_SERVICE_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {

        },
        success: (response) => {
          const service_id = response.data.service_id;
          this.$store.commit('set_custom_service_id', service_id);
          this.showSuccess(response.message);
          setTimeout(() => {
            window.location.reload();
            $('#add_service').modal('hide');
          }, 1500);
        },
        error: (error) => {
          this.showError(error.responseJSON?.message || 'An error occurred while creating the service');
        },
      });
    },
    edit_form(service) {
      if (service) {
        this.selected_service_id = service.id;
        this.service_name = service.service_name;
        this.$nextTick(() => {
          $('#edit_form_modal').modal('show');
        });
      }
    },
    update_form() {
      if (!this.validate_input()) {
        return;
      }

      const TOKEN = localStorage.getItem('token');
      const FORM_DATA = {
        service_name: this.service_name,
        service_id: this.selected_service_id
      };
      const EDIT_FORM_API_URL = `${API_BASE_URL}/verify_api/form_management_api/edit_custom_service_api/`;

      $.ajax({
        url: EDIT_FORM_API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {

        },
        success: () => {
          this.showSuccess('Custom service updated successfully');
          $('#edit_form_modal').modal('hide');
          this.servicesTableKey++;
        },
        error: (error) => {
          let error_message = 'Error updating custom service';

          if (error.responseJSON) {
            const ERROR_RESPONSE = error.responseJSON;

            if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
              error_message = ERROR_RESPONSE.error;

              $('.error-messages').text(error_message).removeClass('d-none');

              setTimeout(() => {
                $('.error-messages').text('').addClass('d-none');
              }, 3000);
            }
          }
          
          this.showError(error_message);
        }
      });
    },

    manage_service(service_id) {
      this.$store.dispatch('update_service_id', service_id);
      this.$router.push({ name: 'manage_form' });
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.get_custom_service();
  }
}
